/*
 * Copyright (c) 2008-2025 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

/**
 * The key of the global attribute defining the base value for a package feature
 */
export const GLOBAL_ATTRIBUTE_KEY = "*"

/**
 * The set of known license features available on any one license package
 */
export const LICENSE_FEATURES = Object.freeze({
  MULTI_USER: "MultiUser",
  JMC_USAGE: "JmcUsage",
  MEETING_RESULTS: "MeetingResults",
  MEETING_ROOM_CAPACITY: "MeetingRoomCapacity",
  MEETING_ROOM_COUNT: "MeetingRoomCount",
  WAITING_ROOM: "WaitingRoom",
  ROLE_BASED_MEETING_SHARING: "RoleBasedMeetingSharing",
  CUSTOM_MEETING_PROPERTIES: "CustomMeetingProperties",
  TIME_TRACKING: "TimeTracking",
  PROXY_VOTING: "ProxyVoting",
  SSO_LOGIN_CONFIG: "OIDCSSO",
  SIMPLE_FEEDBACK_VIEW: "SimpleFeedbackView",
  ACCREDITATION: "Accreditation",
})
